<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import enquireScreen from './utils/device'
import storage from './utils/storage'
import  lazyChannel   from '../src/router/lazyChannel'
import  lazyDistributor from '../src/router/lazyDistributor'
export default {
  name: 'App',
  created () {
    let _this = this;
    let user=storage.get('user');
    const distributorRouter=lazyDistributor.distributorRouter;
    const channelRouter=lazyChannel.channelRouter;
    if(user){
      let old=_this.$router.options.routes.filter((item,index,arr) => {
        return index < 2
      });
      if(user.proxyModelId=='31'){
        _this.$router.addRoutes(channelRouter);
        _this.$router.options.routes=[...old,...channelRouter]
      }
      else if(user.proxyModelId=='32'){
        _this.$router.addRoutes(distributorRouter);
        _this.$router.options.routes=[...old,...distributorRouter]
      }
    }
    enquireScreen(isMobile => {
      _this.$store.commit('setting/setDevice', isMobile)
    })
  }
}
</script>

<style lang="less">
  .fixed-th .ant-table-thead > tr > th{white-space:nowrap;}
  :global{
    #app{height:100%;}
    .ant-layout.ant-layout-has-sider{min-height:100%;}
    //拖拽控件全局样式
    .dragable-ghost{
      border: 1px dashed #aaaaaa;
      opacity: 0.65;
    }
    .dragable-chose{
      border: 1px dashed #aaaaaa;
      opacity: 0.65;
    }
    .dragable-drag{
      border: 1px dashed #aaaaaa;
      opacity: 0.65;
    }
    //页面切换动画
    .page-toggle-enter-active{
      transition: all 0.2s ease-in 0.25s;
    }
    .page-toggle-leave-active{
      transition: all 0.2s ease-out 0s;
    }
    .page-toggle-enter, .page-toggle-leave-to{
      opacity: 0;
      padding: 0px;
    }
    .standard-table .ant-pagination{text-align:right;margin-top:20px;}
    .ant-tabs-bar{margin-bottom:0;}
    .pub-radio-list{display:block !important;}
    .pub-radio-list .ant-radio-wrapper{width:31%;margin-right:2%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}
    
  }
</style>



// WEBPACK FOOTER //
// src/App.vue